import { Component, OnInit } from '@angular/core';
import { AvanzaPraticheService } from '../../../services/avanza-pratiche.service';

@Component({
  selector: 'app-loader-wrapper',
  templateUrl: './loader-wrapper.component.html',
  styleUrls: ['./loader-wrapper.component.css']
})
export class LoaderWrapperComponent implements OnInit {

	title:string = 'GENERAZIONE PRATICHE';
	elaborate:number = 0;
	totali:number = 0;
	showSpinner:boolean = true;
	buttonEnabled:boolean = true;

	constructor(
		private avanzaPratiche:AvanzaPraticheService
		) { }

	ngOnInit() {
	}

	disableButton() {
		this.buttonEnabled = false;
	}

}
